// GiftNiftySection.js
// GIFT Nifty futures snapshot + FII/DII cash-segment cards.
import React from 'react';

const fmt = (n, decimals = 2) =>
    Number(n).toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

const GiftNiftySection = ({ giftNifty }) => {
    if (!giftNifty) return null;

    const { quote, value, change, changePercent } = giftNifty;

    const isUp     = Number(change) >= 0;
    const chgColor = isUp ? '#15803d' : '#dc2626';
    const sign     = isUp ? '+' : '';

    return (
        <div className="gift-nifty-wrapper">
            {/* Quote */}
            {quote && (
                <div className="gift-nifty-quote">
                    "{quote}"
                </div>
            )}

            {/* Price row — only when GIFT Nifty value is available */}
            {value != null && (
                <div className="gift-nifty-row">
                    <span className="gift-nifty-label">Gift Nifty</span>
                    <span className="gift-nifty-value">{fmt(value)}</span>
                    <span style={{ color: chgColor, fontWeight: 600 }}>
                        {sign}{fmt(change)}
                    </span>
                    <span style={{ color: chgColor, fontWeight: 600 }}>
                        {sign}{fmt(changePercent)}%
                    </span>
                </div>
            )}
        </div>
    );
};

export default GiftNiftySection;
